import {
  UIAppContent,
  UIAppSidebar,
  SidebarButtonLogo,
  SidebarButton,
  SidebarBottom,
  SidebarUserMenu,
  useTheme,
  Topbar,
  UIContentMain,
  UIContentTopbar,
} from "@eventsquare/uikit";
import { RiSunLine, RiMoonLine } from "@remixicon/react";
import { Outlet } from "react-router-dom";
import styles from "./AppLayoutWallet.module.scss";
import { Link } from "react-router-dom";

const AppLayout = () => {
  const handleToggleTheme = () => {
    setColorMode(colorMode === "light" ? "dark" : "light");
  };
  const { colorMode, setColorMode } = useTheme();

  return (
    <div className={styles.appLayoutWallet}>
      <UIAppSidebar>
        <Link to="/">
          <SidebarButtonLogo />
        </Link>
        <SidebarBottom>
          <SidebarUserMenu
            translations={{
              switch_account: "test",
              logout: "test",
              change_avatar: "test",
              switch_language: "test",
              languages: {
                nl: "test",
                en: "test",
                fr: "test",
              },
            }}
          />
          <SidebarButton
            icon={colorMode === "light" ? RiSunLine : RiMoonLine}
            label={colorMode === "light" ? "test" : "test"}
            onClick={handleToggleTheme}
          />
        </SidebarBottom>
      </UIAppSidebar>
      <UIAppContent>
        <UIContentTopbar>
          <Topbar hideTablet />
        </UIContentTopbar>
        <UIContentMain>
          <Outlet />
        </UIContentMain>
      </UIAppContent>
    </div>
  );
};

export default AppLayout;
